import { Component, OnInit, Input } from '@angular/core';
import { Endpoint } from 'src/app/models/endpoint';

@Component({
    selector: 'app-endpoint-card',
    templateUrl: './endpoint-card.component.html',
    styleUrls: ['./endpoint-card.component.scss'],
    standalone: false
})
export class EndpointCardComponent implements OnInit {

  @Input() endpoint: Endpoint;

  constructor() { }

  ngOnInit(): void {
  }

  openUrl() {
    window.open('https://www.google.com', '_blank', 'noopener');
  }

}
